<template>
  <h1 v-if="isLoggedIn" class="title mr-[15px] mt-8 pb-6 md:mt-[45px] md:pb-[64px]">
    Hello, {{ user?.first_name }}!
  </h1>
  <div v-if="isLoggedIn" class="flex flex-col max-lg:justify-between md:flex-row">
    <div
      class="left_side-wrapper scrollbar-hidden flex-nowrap overflow-x-scroll md:mr-[19.18%] md:overflow-x-visible"
    >
      <button
        @click="newRide"
        type="button"
        class="summary_edit_button m-0 max-w-[175px] text-nowrap px-[22px] py-[8px] font-bold md:px-[16px] md:py-[8px]"
      >
        Book a New Ride <span class="account__button__disc"></span>
      </button>
      <router-link to="/account/accountinformation" class="account__button text-nowrap"
        >Account Information <span class="account__button__disc"></span
      ></router-link>
      <router-link to="/account/ridehistory" class="account__button text-nowrap"
        >Ride History <span class="account__button__disc"></span
      ></router-link>
      <button type="button" class="account__button active text-nowrap">
        Agency information <span class="account__button__disc"></span>
      </button>
      <button v-if="!isMobile" @click="logOut" type="button" class="account__button text-[#878787]">
        Log Out
      </button>
    </div>
    <div v-if="isMobile" class="mt-[6px]">
      <button @click="logOut" type="button" class="account__button text-[#878787]">Log Out</button>
    </div>

    <div class="rounded-[40px] bg-[#333639] text-[20px] md:text-[40px]">
      <Form
        @submit="onFormSubmit"
        class="form"
        :validation-schema="agencySchema"
        v-slot="{ errors, isSubmitting }"
      >
        <span v-if="isSubmitting">
          {{ errorFill(errors) }}
        </span>
        <div
          class="flex w-full flex-col items-start justify-start gap-4 self-stretch rounded-[40px] bg-white px-4 pb-3 pt-6 dark:bg-[#333639] sm:px-8 sm:pb-8 sm:pt-[60px]"
        >
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full lg:max-w-44">
              <div
                @click="isEditable && toggleDropdown()"
                :class="[!isEditable ? '!cursor-not-allowed !text-[#6c6d6f]' : '']"
                class="text-background dark:bg-background flex w-full cursor-pointer items-center justify-between rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none dark:border-[#3D4043] dark:text-white md:text-lg"
              >
                <p v-if="!agency.title" class="text-[#878787]">
                  Select <span class="text-[#E30000]">*</span>
                </p>
                <p v-else>{{ agency.title }}</p>
                <img class="dark:invert" src="@/assets/dli/images/select_arrow.png" alt="" />
              </div>
              <div
                v-if="isOpen"
                class="dark:bg-background absolute z-10 mt-12 h-max w-full space-y-1 rounded-[20px] border border-[#878787] bg-[#F4F6F3] px-3 py-5 text-sm text-[#878787] dark:border-[#3D4043]"
              >
                <div
                  v-for="option in options"
                  :key="option"
                  @click="selectOption(option)"
                  class="hover:text-background cursor-pointer rounded-full p-3 hover:bg-[#CCF2C8] dark:hover:bg-[#CCF2C8]/5 dark:hover:text-white"
                  :class="{
                    'text-background pointer-events-none !cursor-default bg-[#CCF2C8] dark:bg-[#CCF2C8]/5 dark:text-white':
                      agency.title === option
                  }"
                >
                  {{ option }}
                </div>
              </div>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="absolute top-[-28px] hidden text-[14px] text-[#878787] lg:block">
                Contact Person
              </span>
              <input
                disabled
                v-model="first_name"
                placeholder="First name"
                class="dark:bg-background w-full cursor-not-allowed rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] !text-[#878787] outline-none placeholder:text-[#878787] dark:border-[#3D4043] dark:text-white md:text-lg"
              />
            </div>
            <input
              disabled
              v-model="last_name"
              placeholder="Last name"
              class="dark:bg-background w-full cursor-not-allowed rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] !text-[#878787] outline-none placeholder:text-[#878787] dark:border-[#3D4043] dark:text-white md:text-lg"
            />
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row lg:items-end">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Company name<span class="text-[#E30000]">*</span>
              </span>
              <Field name="company_name">
                <input
                  :class="[
                    errors.company_name ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.company_name"
                  placeholder="Company name"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <input
                v-model="email"
                placeholder="Email"
                class="dark:bg-background w-full cursor-not-allowed rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] !text-[#878787] outline-none placeholder:text-[#878787] dark:border-[#3D4043] dark:text-white md:text-lg"
              />
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> IATA Code </span>
              <Field name="iata_code">
                <input
                  :class="[
                    errors.iata_code ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.iata_code"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Alternative Industry Code </span>
              <Field name="alternative_industry_code">
                <input
                  :class="[
                    errors.alternative_industry_code ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.alternative_industry_code"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                VAT number<span class="text-[#E30000]">*</span>
              </span>
              <Field name="vat">
                <input
                  :class="[
                    errors.vat ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.vat"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Fiscal Code </span>
              <Field name="fiscal_code">
                <input
                  :class="[
                    errors.fiscal_code ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.fiscal_code"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Tax ID code </span>
              <Field name="tax_id_code">
                <input
                  :class="[
                    errors.tax_id_code ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.tax_id_code"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> SDI Code </span>
              <Field name="sdi_code">
                <input
                  :class="[
                    errors.sdi_code ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.sdi_code"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Country<span class="text-[#E30000]">*</span>
              </span>
              <Field name="country">
                <select
                  :class="[
                    errors.country ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.country"
                  class="text-background dark:bg-background max-h-[60px] w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                >
                  <option v-for="(val, index) of countries" :key="index">{{ val }}</option>
                </select>
              </Field>
            </div>
            <div class="flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Region/State/Province<span class="text-[#E30000]">*</span>
              </span>
              <Field name="region">
                <input
                  :class="[
                    errors.region ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.region"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                City<span class="text-[#E30000]">*</span>
              </span>
              <Field name="city">
                <input
                  :class="[
                    errors.city ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.city"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col lg:w-5/12">
              <span class="mb-2 text-[14px] text-[#878787]">
                CAP/ZIP<span class="text-[#E30000]">*</span>
              </span>
              <Field name="cap_zip">
                <input
                  :class="[
                    errors.cap_zip ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.cap_zip"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Address<span class="text-[#E30000]">*</span>
              </span>
              <Field name="address">
                <input
                  :class="[
                    errors.address ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.address"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
            <div class="relative flex w-full flex-col lg:w-5/12">
              <span class="mb-2 text-[14px] text-[#878787]"> Internal number </span>
              <Field name="internal_number">
                <input
                  :class="[
                    errors.internal_number ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.internal_number"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Company Main Phone<span class="text-[#E30000]">*</span>
              </span>
              <div class="ym-record-keys max-h-[60px] w-full rounded-[53px]" maxlength="230">
                <vue-tel-input
                  :key="country_prefix"
                  v-model="agency.company_main_phone"
                  @country-changed="(country) => countryChanged(country, 'main')"
                  v-on:beforeinput="validPhone($event, country_prefix)"
                  class="vue-tel-input pl-25 text-background dark:!bg-background border !border-[#878787] !bg-[#E8EDE8]/50 text-sm placeholder:text-[#878787] dark:!border-[#3D4043] dark:!text-white md:text-lg"
                  placeholder="Enter a phone number"
                  :disabled="!isEditable"
                  :class="[!isEditable ? 'tel-text-color' : '']"
                  v-bind="bindProps"
                  :autoDefaultCountry="!agency.company_main_phone"
                  :defaultCountry="country_prefix"
                ></vue-tel-input>
              </div>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]">
                Company Main email<span class="text-[#E30000]">*</span>
              </span>
              <Field name="company_main_email">
                <input
                  :class="[
                    errors.company_main_email ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.company_main_email"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Operations Phone </span>
              <div class="ym-record-keys max-h-[60px] w-full rounded-[53px]" maxlength="230">
                <vue-tel-input
                  :key="country_prefix_operations"
                  v-model="agency.operations_phone"
                  @country-changed="(country) => countryChanged(country, 'operations')"
                  v-on:beforeinput="validPhone($event, country_prefix_operations)"
                  class="vue-tel-input pl-25 text-background dark:!bg-background border !border-[#878787] !bg-[#E8EDE8]/50 text-sm placeholder:text-[#878787] dark:!border-[#3D4043] dark:!text-white md:text-lg"
                  placeholder="Enter a phone number"
                  v-bind="bindProps"
                  :disabled="!isEditable"
                  :class="[!isEditable ? 'tel-text-color' : '']"
                  :autoDefaultCountry="!agency.operations_phone"
                  :defaultCountry="country_prefix_operations"
                ></vue-tel-input>
              </div>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Operations email </span>
              <Field name="operations_email">
                <input
                  :class="[
                    errors.operations_email ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.operations_email"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Booking Phone </span>
              <div class="ym-record-keys max-h-[60px] w-full rounded-[53px]" maxlength="230">
                <vue-tel-input
                  :key="country_prefix_booking"
                  v-model="agency.booking_phone"
                  @country-changed="(country) => countryChanged(country, 'booking')"
                  v-on:beforeinput="validPhone($event, country_prefix_booking)"
                  class="vue-tel-input pl-25 text-background dark:!bg-background border !border-[#878787] !bg-[#E8EDE8]/50 text-sm placeholder:text-[#878787] dark:!border-[#3D4043] dark:!text-white md:text-lg"
                  placeholder="Enter a phone number"
                  v-bind="bindProps"
                  :disabled="!isEditable"
                  :class="[!isEditable ? 'tel-text-color' : '']"
                  :autoDefaultCountry="!agency.booking_phone"
                  :defaultCountry="country_prefix_booking"
                ></vue-tel-input>
              </div>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Booking email </span>
              <Field name="booking_email">
                <input
                  :class="[
                    errors.booking_email ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.booking_email"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="flex w-full flex-col gap-4 lg:flex-row">
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Administration Phone </span>
              <div class="ym-record-keys max-h-[60px] w-full rounded-[53px]" maxlength="230">
                <vue-tel-input
                  :key="country_prefix_administration"
                  v-model="agency.administration_phone"
                  @country-changed="(country) => countryChanged(country, 'administration')"
                  v-on:beforeinput="validPhone($event, country_prefix_administration)"
                  class="vue-tel-input pl-25 text-background dark:!bg-background border !border-[#878787] !bg-[#E8EDE8]/50 text-sm placeholder:text-[#878787] dark:!border-[#3D4043] dark:!text-white md:text-lg"
                  placeholder="Enter a phone number"
                  v-bind="bindProps"
                  :disabled="!isEditable"
                  :class="[!isEditable ? 'tel-text-color' : '']"
                  :autoDefaultCountry="!agency.administration_phone"
                  :defaultCountry="country_prefix_administration"
                ></vue-tel-input>
              </div>
            </div>
            <div class="relative flex w-full flex-col">
              <span class="mb-2 text-[14px] text-[#878787]"> Administration email </span>
              <Field name="administration_email">
                <input
                  :class="[
                    errors.administration_email ? '!border-red-500' : '',
                    !isEditable ? '!text-[#6c6d6f]' : ''
                  ]"
                  :disabled="!isEditable"
                  v-model="agency.administration_email"
                  class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
                />
              </Field>
            </div>
          </div>
          <div class="relative flex w-full flex-col">
            <span class="mb-2 text-[14px] text-[#878787]">
              ERP Enterprise resource planning used
            </span>
            <Field name="erp_enterprise">
              <input
                :class="[
                  errors.erp_enterprise ? '!border-red-500' : '',
                  !isEditable ? '!text-[#6c6d6f]' : ''
                ]"
                :disabled="!isEditable"
                v-model="agency.erp_enterprise"
                class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
              />
            </Field>
          </div>
          <div class="relative mb-6 flex w-full flex-col">
            <span class="mb-2 text-[14px] text-[#878787]"> Additional notes </span>
            <Field name="additional_notes">
              <input
                :class="[
                  errors.additional_notes ? '!border-red-500' : '',
                  !isEditable ? '!text-[#6c6d6f]' : ''
                ]"
                :disabled="!isEditable"
                v-model="agency.additional_notes"
                class="text-background dark:bg-background w-full rounded-[53px] border border-[#878787] bg-[#E8EDE8]/50 px-[22px] py-4 text-sm tracking-[-0.28px] outline-none placeholder:text-[#878787] disabled:cursor-not-allowed dark:border-[#3D4043] dark:text-white md:text-lg"
              />
            </Field>
          </div>
          <button
            type="button"
            v-if="!isEditable"
            class="summary_edit_button border-dark_main text-dark_main dark:text-main dark:border-main dark:hover:text-background w-full px-4 py-[18px] text-base/[17.6px] md:py-5 md:text-[18px]/[23.8px]"
            @click="openEdit()"
          >
            Edit
          </button>
          <button
            :disabled="loading"
            type="submit"
            v-if="isEditable"
            class="summary_edit_button save w-full px-4 py-[18px] text-base/[17.6px] md:py-5 md:text-[18px]/[23.8px]"
          >
            <LoadingSpinner
              v-if="loading"
              class="size-[18px] animate-spin stroke-[#2B2D32] md:size-6"
            />
            <span v-else>Save</span>
          </button>
        </div>
      </Form>
    </div>
  </div>
  <h1 v-if="!isLoggedIn" class="title mr-[15px] mt-[5rem]">
    Please login to view account information
  </h1>
  <router-link v-if="!isLoggedIn" to="/account/signin" class="button mt-[15px] w-fit"
    >Sign in
  </router-link>
  <swipe-modal
    v-model="isModal"
    v-if="isMobile"
    contents-height="60vh"
    border-top-radius="16px"
    background-color="ffffff"
    tip-color="#CDCFD0"
  >
    <car-popup-content />
  </swipe-modal>
</template>

<script setup>
import swipeModal from '@takuma-ru/vue-swipe-modal'
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMobile } from '@/compose/ismobile'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { validPhone } from '@/plugins/validPhone'
import { Field, Form } from 'vee-validate'
import { ref, reactive, inject, watch, onBeforeMount } from 'vue'
import * as yup from 'yup'
import { useFetcher } from '@/compose/axios'
import CarPopupContent from '@/components/features/car/CarPopupContent.vue'
import { useOrderStore, useRidesHistoryStore } from '@/stores'
import LoadingSpinner from '@/components/ui/icons/LoadingSpinner.vue'

const ridesStore = useRidesHistoryStore()
const isModal = ref(false)

const { isMobile } = useMobile()

const utils = inject('utils')
const orderStore = useOrderStore()
const userStore = useUserStore()
const router = useRouter()
const isAgencyHasData = ref(false)

const { isLoggedIn, user } = storeToRefs(userStore)
const options = ['Mr.', 'Ms.', 'Mrs.', 'Miss', 'Mx.', 'Dr.', 'Prof.']
const isOpen = ref(false)
const loading = ref(false)
const first_name = ref(user.value.first_name || '')
const last_name = ref(user.value.last_name || '')
const email = ref(user.value.email || '')
const agency = ref({
  title: '',
  company_name: '',
  email: '',
  vat: '',
  fiscal_code: '',
  tax_id_code: '',
  sdi_code: '',
  country: '',
  address: '',
  cap_zip: '',
  region: '',
  city: '',
  iata_code: '',
  internal_number: '',
  alternative_industry_code: '',
  company_main_phone: '',
  company_main_phone_code: '',
  company_main_email: '',
  operations_phone: '',
  operations_phone_code: '',
  operations_email: '',
  booking_email: '',
  booking_phone: '',
  booking_phone_code: '',
  administration_phone: '',
  administration_phone_code: '',
  administration_email: '',
  erp_enterprise: '',
  additional_notes: ''
})

let isEditable = ref(false)

const noField = ref(true)
const country_prefix = ref(null)
const country_prefix_operations = ref(null)
const country_prefix_booking = ref(null)
const country_prefix_administration = ref(null)
const isShowModal = ref(true)
const errorOnForm = ref(null)

const { axiosInstance } = useFetcher({ baseUrl: import.meta.env.VITE_APP_API_URL })

const agencySchema = computed(() =>
  !agency.value || Object.keys(agency.value).length === 0 ? requiredSchema : optionalSchema
)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectOption = (option) => {
  agency.value.title = option
  isOpen.value = false
}
const newRide = () => {
  orderStore.$reset()
  orderStore.changeTypeOrder('NEW')
  router.push({ name: 'home' })
}

function logOut() {
  ridesStore.$reset()
  userStore.preventLogout()
  setTimeout(function () {
    router.push('/account/signin')
  }, 100)
}

const errorFill = (errorBag) => {
  errorOnForm.value = errorBag
}

watch(errorOnForm, (newVal) => {
  if (!utils.isEmpty(newVal)) {
    isShowModal.value = true
  }
})

const countries = [
  'Åland Islands',
  'Afghanistan',
  'Akrotiri',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Ashmore and Cartier Islands',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Bassas Da India',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burma',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Caribbean Netherlands',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Clipperton Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Cook Islands',
  'Coral Sea Islands',
  'Costa Rica',
  'Cote D’Ivoire',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Democratic Republic of the Congo',
  'Denmark',
  'Dhekelia',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Europa Island',
  'Falkland Islands (Islas Malvinas)',
  'Faroe Islands',
  'Federated States of Micronesia',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern and Antarctic Lands',
  'Gabon',
  'Gaza Strip',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Glorioso Islands',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-bissau',
  'Guyana',
  'Haiti',
  'Heard Island and Mcdonald Islands',
  'Holy See (Vatican City)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Jan Mayen',
  'Japan',
  'Jersey',
  'Jordan',
  'Juan De Nova Island',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Navassa Island',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'North Korea',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paracel Islands',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn Islands',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of the Congo',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint BarthÃ©lemy',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Korea',
  'South Sudan',
  'Spain',
  'Spratly Islands',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'The Bahamas',
  'The Gambia',
  'Timor-leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tromelin Island',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Virgin Islands',
  'Wake Island',
  'Wallis and Futuna',
  'West Bank',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
]
const countryCodes = [
  { prefix: 'AX', code: '358' },
  { prefix: 'AF', code: '93' },
  { prefix: 'AL', code: '355' },
  { prefix: 'DZ', code: '213' },
  { prefix: 'AS', code: '1684' },
  { prefix: 'AD', code: '376' },
  { prefix: 'AO', code: '244' },
  { prefix: 'AI', code: '1264' },
  { prefix: 'AQ', code: '672' },
  { prefix: 'AG', code: '1268' },
  { prefix: 'AR', code: '54' },
  { prefix: 'AM', code: '374' },
  { prefix: 'AW', code: '297' },
  { prefix: 'AU', code: '61' },
  { prefix: 'AT', code: '43' },
  { prefix: 'AZ', code: '994' },
  { prefix: 'BS', code: '1242' },
  { prefix: 'BH', code: '973' },
  { prefix: 'BD', code: '880' },
  { prefix: 'BB', code: '1246' },
  { prefix: 'BY', code: '375' },
  { prefix: 'BE', code: '32' },
  { prefix: 'BZ', code: '501' },
  { prefix: 'BJ', code: '229' },
  { prefix: 'BM', code: '1441' },
  { prefix: 'BT', code: '975' },
  { prefix: 'BO', code: '591' },
  { prefix: 'BA', code: '387' },
  { prefix: 'BW', code: '267' },
  { prefix: 'BR', code: '55' },
  { prefix: 'IO', code: '246' },
  { prefix: 'VG', code: '1284' },
  { prefix: 'BN', code: '673' },
  { prefix: 'BG', code: '359' },
  { prefix: 'BF', code: '226' },
  { prefix: 'MM', code: '95' },
  { prefix: 'BI', code: '257' },
  { prefix: 'KH', code: '855' },
  { prefix: 'CM', code: '237' },
  { prefix: 'CV', code: '238' },
  { prefix: 'BQ', code: '599' },
  { prefix: 'KY', code: '1345' },
  { prefix: 'CF', code: '236' },
  { prefix: 'TD', code: '235' },
  { prefix: 'CL', code: '56' },
  { prefix: 'CN', code: '86' },
  { prefix: 'CX', code: '61' },
  { prefix: 'CC', code: '61' },
  { prefix: 'CO', code: '57' },
  { prefix: 'KM', code: '269' },
  { prefix: 'CK', code: '682' },
  { prefix: 'CR', code: '506' },
  { prefix: 'CI', code: '225' },
  { prefix: 'HR', code: '385' },
  { prefix: 'CU', code: '53' },
  { prefix: 'CW', code: '599' },
  { prefix: 'CY', code: '357' },
  { prefix: 'CZ', code: '420' },
  { prefix: 'CD', code: '243' },
  { prefix: 'DK', code: '45' },
  { prefix: 'DJ', code: '253' },
  { prefix: 'DM', code: '1767' },
  { prefix: 'DO', code: '1809' },
  { prefix: 'EC', code: '593' },
  { prefix: 'EG', code: '20' },
  { prefix: 'SV', code: '503' },
  { prefix: 'GQ', code: '240' },
  { prefix: 'ER', code: '291' },
  { prefix: 'EE', code: '372' },
  { prefix: 'ET', code: '251' },
  { prefix: 'FK', code: '500' },
  { prefix: 'FO', code: '298' },
  { prefix: 'FJ', code: '679' },
  { prefix: 'FI', code: '358' },
  { prefix: 'FR', code: '33' },
  { prefix: 'GF', code: '594' },
  { prefix: 'PF', code: '689' },
  { prefix: 'GA', code: '241' },
  { prefix: 'GM', code: '220' },
  { prefix: 'GE', code: '995' },
  { prefix: 'DE', code: '49' },
  { prefix: 'GH', code: '233' },
  { prefix: 'GI', code: '350' },
  { prefix: 'GR', code: '30' },
  { prefix: 'GL', code: '299' },
  { prefix: 'GD', code: '1473' },
  { prefix: 'GP', code: '590' },
  { prefix: 'GU', code: '1671' },
  { prefix: 'GT', code: '502' },
  { prefix: 'GG', code: '44' },
  { prefix: 'GN', code: '224' },
  { prefix: 'GW', code: '245' },
  { prefix: 'GY', code: '592' },
  { prefix: 'HT', code: '509' },
  { prefix: 'HN', code: '504' },
  { prefix: 'HK', code: '852' },
  { prefix: 'HU', code: '36' },
  { prefix: 'IS', code: '354' },
  { prefix: 'IN', code: '91' },
  { prefix: 'ID', code: '62' },
  { prefix: 'IR', code: '98' },
  { prefix: 'IQ', code: '964' },
  { prefix: 'IE', code: '353' },
  { prefix: 'IM', code: '44' },
  { prefix: 'IL', code: '972' },
  { prefix: 'IT', code: '39' },
  { prefix: 'JM', code: '1876' },
  { prefix: 'JP', code: '81' },
  { prefix: 'JE', code: '44' },
  { prefix: 'JO', code: '962' },
  { prefix: 'KE', code: '254' },
  { prefix: 'KI', code: '686' },
  { prefix: 'XK', code: '383' },
  { prefix: 'KW', code: '965' },
  { prefix: 'KG', code: '996' },
  { prefix: 'LA', code: '856' },
  { prefix: 'LV', code: '371' },
  { prefix: 'LB', code: '961' },
  { prefix: 'LS', code: '266' },
  { prefix: 'LR', code: '231' },
  { prefix: 'LY', code: '218' },
  { prefix: 'LI', code: '423' },
  { prefix: 'LT', code: '370' },
  { prefix: 'LU', code: '352' },
  { prefix: 'MO', code: '853' },
  { prefix: 'MK', code: '389' },
  { prefix: 'MG', code: '261' },
  { prefix: 'MW', code: '265' },
  { prefix: 'MY', code: '60' },
  { prefix: 'MV', code: '960' },
  { prefix: 'ML', code: '223' },
  { prefix: 'MT', code: '356' },
  { prefix: 'MH', code: '692' },
  { prefix: 'MQ', code: '596' },
  { prefix: 'MR', code: '222' },
  { prefix: 'MU', code: '230' },
  { prefix: 'YT', code: '262' },
  { prefix: 'MX', code: '52' },
  { prefix: 'MD', code: '373' },
  { prefix: 'MC', code: '377' },
  { prefix: 'MN', code: '976' },
  { prefix: 'ME', code: '382' },
  { prefix: 'MS', code: '1664' },
  { prefix: 'MA', code: '212' },
  { prefix: 'MZ', code: '258' },
  { prefix: 'NA', code: '264' },
  { prefix: 'NR', code: '674' },
  { prefix: 'NP', code: '977' },
  { prefix: 'NL', code: '31' },
  { prefix: 'NC', code: '687' },
  { prefix: 'NZ', code: '64' },
  { prefix: 'NI', code: '505' },
  { prefix: 'NE', code: '227' },
  { prefix: 'NG', code: '234' },
  { prefix: 'NU', code: '683' },
  { prefix: 'NF', code: '672' },
  { prefix: 'KP', code: '850' },
  { prefix: 'MP', code: '1670' },
  { prefix: 'NO', code: '47' },
  { prefix: 'OM', code: '968' },
  { prefix: 'PK', code: '92' },
  { prefix: 'PW', code: '680' },
  { prefix: 'PS', code: '970' },
  { prefix: 'PA', code: '507' },
  { prefix: 'PG', code: '675' },
  { prefix: 'PY', code: '595' },
  { prefix: 'PE', code: '51' },
  { prefix: 'PH', code: '63' },
  { prefix: 'PN', code: '64' },
  { prefix: 'PL', code: '48' },
  { prefix: 'PT', code: '351' },
  { prefix: 'PR', code: '1787' },
  { prefix: 'QA', code: '974' },
  { prefix: 'CG', code: '242' },
  { prefix: 'RE', code: '262' },
  { prefix: 'RO', code: '40' },
  { prefix: 'RU', code: '7' },
  { prefix: 'RW', code: '250' },
  { prefix: 'BL', code: '590' },
  { prefix: 'SH', code: '290' },
  { prefix: 'KN', code: '1869' },
  { prefix: 'LC', code: '1758' },
  { prefix: 'MF', code: '590' },
  { prefix: 'PM', code: '508' },
  { prefix: 'VC', code: '1784' },
  { prefix: 'WS', code: '685' },
  { prefix: 'SM', code: '378' },
  { prefix: 'ST', code: '239' },
  { prefix: 'SA', code: '966' },
  { prefix: 'SN', code: '221' },
  { prefix: 'RS', code: '381' },
  { prefix: 'SC', code: '248' },
  { prefix: 'SL', code: '232' },
  { prefix: 'SG', code: '65' },
  { prefix: 'SX', code: '1721' },
  { prefix: 'SK', code: '421' },
  { prefix: 'SI', code: '386' },
  { prefix: 'SB', code: '677' },
  { prefix: 'SO', code: '252' },
  { prefix: 'ZA', code: '27' },
  { prefix: 'KR', code: '82' },
  { prefix: 'SS', code: '211' },
  { prefix: 'ES', code: '34' },
  { prefix: 'LK', code: '94' },
  { prefix: 'SD', code: '249' },
  { prefix: 'SR', code: '597' },
  { prefix: 'SJ', code: '47' },
  { prefix: 'SZ', code: '268' },
  { prefix: 'SE', code: '46' },
  { prefix: 'CH', code: '41' },
  { prefix: 'SY', code: '963' },
  { prefix: 'TW', code: '886' },
  { prefix: 'TJ', code: '992' },
  { prefix: 'TZ', code: '255' },
  { prefix: 'TH', code: '66' },
  { prefix: 'GM', code: '220' },
  { prefix: 'TL', code: '670' },
  { prefix: 'TG', code: '228' },
  { prefix: 'TK', code: '690' },
  { prefix: 'TO', code: '676' },
  { prefix: 'TT', code: '1868' },
  { prefix: 'TN', code: '216' },
  { prefix: 'TR', code: '90' },
  { prefix: 'TM', code: '993' },
  { prefix: 'TC', code: '1649' },
  { prefix: 'TV', code: '688' },
  { prefix: 'UG', code: '256' },
  { prefix: 'UA', code: '380' },
  { prefix: 'AE', code: '971' },
  { prefix: 'GB', code: '44' },
  { prefix: 'US', code: '1' },
  { prefix: 'UY', code: '598' },
  { prefix: 'UZ', code: '998' },
  { prefix: 'VU', code: '678' },
  { prefix: 'VE', code: '58' },
  { prefix: 'VN', code: '84' },
  { prefix: 'VI', code: '1340' },
  { prefix: 'WF', code: '681' },
  { prefix: 'EH', code: '212' },
  { prefix: 'YE', code: '967' },
  { prefix: 'ZM', code: '260' },
  { prefix: 'ZW', code: '263' }
]

const openEdit = () => {
  isEditable.value = true
}

const requiredSchema = yup.object({
  company_name: yup.string().required('Company name is required'),
  country: yup.string().required('Country is required'),
  region: yup.string().required('Region/State/Province is required'),
  city: yup.string().required('City is required'),
  address: yup.string().required('Address is required'),
  cap_zip: yup.string().required('CAP/ZIP is required'),
  company_main_email: yup.string().email('Invalid email'),
  operations_email: yup.string().email('Invalid email'),
  booking_email: yup.string().email('Invalid email'),
  administration_email: yup.string().email('Invalid email'),
  vat: yup.string().required(),
  fiscal_code: yup.string(),
  tax_id_code: yup.string(),
  sdi_code: yup.string(),
  internal_number: yup.string(),
  iata_code: yup.string(),
  alternative_industry_code: yup.string(),
  company_main_phone: yup.string(),
  operations_phone: yup.string(),
  booking_phone: yup.string(),
  administration_phone: yup.string(),
  erp_enterprise: yup.string(),
  additional_notes: yup.string()
})

const optionalSchema = yup.object({
  company_name: yup.string(),
  country: yup.string(),
  region: yup.string(),
  city: yup.string(),
  address: yup.string(),
  cap_zip: yup.string(),
  company_main_email: yup.string().email('Invalid email'),
  operations_email: yup.string().email('Invalid email'),
  booking_email: yup.string().email('Invalid email'),
  administration_email: yup.string().email('Invalid email'),
  vat: yup.string(),
  fiscal_code: yup.string(),
  tax_id_code: yup.string(),
  sdi_code: yup.string(),
  internal_number: yup.string(),
  iata_code: yup.string(),
  alternative_industry_code: yup.string(),
  company_main_phone: yup.string(),
  operations_phone: yup.string(),
  booking_phone: yup.string(),
  administration_phone: yup.string(),
  erp_enterprise: yup.string(),
  additional_notes: yup.string()
})

const countryChanged = (country, type) => {
  if (!country) return

  if (type === 'main') {
    agency.value.company_main_phone_code = country.dialCode || ''
    country_prefix.value = country.iso2 || ''
  }
  if (type === 'operations') {
    agency.value.operations_phone_code = country.dialCode || ''
    country_prefix_operations.value = country.iso2 || ''
  }
  if (type === 'booking') {
    agency.value.booking_phone_code = country.dialCode || ''
    country_prefix_booking.value = country.iso2 || ''
  }
  if (type === 'administration') {
    agency.value.administration_phone_code = country.dialCode || ''
    country_prefix_administration.value = country.iso2 || ''
  }
}

const checkTurnMessengers = (e = null, isNoField = false) => {
  if (!isNoField) {
    if (agency.value.isTelegram || agency.value.isWhatsApp) {
      noField.value = false
    } else {
      noField.value = true
    }
  } else {
    if (e.target.checked === true) {
      agency.value.isTelegram = false
      agency.value.isWhatsApp = false
    }
  }
}

const preferredCountries = ['us', 'it', 'au', 'uk', 'in', 'ca', 'il', 'sg', 'ae']

const defaultSettingsProps = ref({
  mode: 'auto',
  preferredCountries: preferredCountries,
  inputClasses: 'input',
  dropdownOptions: {
    showFlags: true,
    showDialCodeInList: true,
    showDialCodeInSelection: true
  }
})

const bindProps = reactive({
  inputOptions: {
    placeholder: 'Mobile Phone Number'
  },
  ...defaultSettingsProps.value
})

const cleanPhoneNumber = (phoneNumber) => {
  const cleanNumber = phoneNumber.replace(/^\+(\d+)\s/, '')
  return cleanNumber.replace(/\D/g, '')
}

const onFormSubmit = () => {
  loading.value = true

  let data = {
    ...agency.value,
    company_main_phone: cleanPhoneNumber(agency.value.company_main_phone),
    operations_phone: cleanPhoneNumber(agency.value.operations_phone),
    booking_phone: cleanPhoneNumber(agency.value.booking_phone),
    administration_phone: cleanPhoneNumber(agency.value.administration_phone),
    title: agency.value.title ? agency.value.title.replace(/\.$/, '') : '',
    company_main_phone_code: agency.value.company_main_phone
      ? agency.value.company_main_phone_code
      : '',
    operations_phone_code: agency.value.operations_phone ? agency.value.operations_phone_code : '',
    booking_phone_code: agency.value.booking_phone ? agency.value.booking_phone_code : '',
    administration_phone_code: agency.value.administration_phone
      ? agency.value.administration_phone_code
      : ''
  }

  axiosInstance
    .post('/account', data)
    .then(() => {
      loading.value = false
      isEditable.value = false
      getAccInfo()
    })
    .catch(() => {
      loading.value = false
    })
}

const getCountryPrefixByCode = (countryCode) => {
  const country = countryCodes.find((item) => item.code === countryCode)
  return country ? country.prefix : null
}

const getAccInfo = async () => {
  try {
    const res = await axiosInstance.get('/account')

    if (res.data && res.data.data && Object.keys(res.data.data).length > 0) {
      isAgencyHasData.value = true
    } else {
      isAgencyHasData.value = false
    }

    if (res.data.data) {
      let data = res.data.data

      const removeCountryCode = (phone) => {
        if (!phone || typeof phone !== 'string') return ''
        const digitsOnly = phone.replace(/\D/g, '')
        return digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly
      }

      data.company_main_phone = removeCountryCode(data.company_main_phone || '')
      data.operations_phone = removeCountryCode(data.operations_phone || '')
      data.booking_phone = removeCountryCode(data.booking_phone || '')
      data.administration_phone = removeCountryCode(data.administration_phone || '')

      agency.value = data

      country_prefix.value = getCountryPrefixByCode(data.company_main_phone_code) || null
      country_prefix_operations.value = getCountryPrefixByCode(data.operations_phone_code) || null
      country_prefix_booking.value = getCountryPrefixByCode(data.booking_phone_code) || null
      country_prefix_administration.value =
        getCountryPrefixByCode(data.administration_phone_code) || null
    }
  } catch (error) {
    console.error('Ошибка при получении данных аккаунта:', error)
    isAgencyHasData.value = false
  }
}

onBeforeMount(() => {
  checkTurnMessengers()
  orderStore.update({ paymentSuccess: true })
})
onMounted(() => {
  getAccInfo()
})
</script>

<style>
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

.scrollbar-hidden {
  scrollbar-width: none;
}

.tel-text-color .vti__dropdown span {
  color: #6c6d6f !important;
}

.tel-text-color input {
  color: #6c6d6f !important;
}
</style>
